import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPageLandscape: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlankPageLandscape"><Path d="M21 4.5H2.5V11.9286C2.5 14.4326 3.67497 16.7905 5.67143 18.2929C6.28139 18.7519 7.02327 19 7.78571 19H21V4.5Z" stroke="currentColor"/><Path d="M2.5 5.44727C2.5 8.18231 3.58283 10.8053 5.51029 12.7393L6.61111 13.8438C5.58333 15.3907 5.58333 19.0001 8.15278 19.0001" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlankPageLandscape;
